/**
 * Glass video button on the product gallery (snippets/babalu-gallery-video-button).
 *
 * - Visible only while the gallery has a video slide and it is not the current
 *   slide. Color filters can hide the slide, so it is checked on every change.
 * - Click: goes to the video with the slider's own API and plays it inside the
 *   tap, which iOS Low Power Mode requires. Autoplay on screen stays in
 *   babalu-video-autoplay.js.
 *
 * Author: NOVADEHA / Felipe Ocampo
 */
(function () {
  'use strict';

  var SLIDE = '.hdt-product__media-item[data-media-type="video"]:not([hidden]), .hdt-product__media-item[data-media-type="external_video"]:not([hidden])';

  function init(button) {
    if (button.dataset.babaluReady) return;
    button.dataset.babaluReady = 'true';
    var gallery = button.closest('hdt-product-media');
    var slider = gallery && gallery.querySelector('hdt-slider');
    if (!slider) return;

    function slide() {
      return slider.querySelector(SLIDE);
    }

    function sync() {
      var target = slide();
      button.hidden = !target || target.classList.contains('is-selected');
    }

    button.addEventListener('click', function () {
      var target = slide();
      if (!target) return;
      if (slider.isActive === false || typeof slider.goToTarget !== 'function') {
        target.scrollIntoView({ block: 'center' });
      } else {
        slider.goToTarget(target);
      }
      var video = target.querySelector('video');
      if (!video) return;
      video.focus({ preventScroll: true });
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    });

    new MutationObserver(sync).observe(slider, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden'],
    });
    sync();
  }

  document.querySelectorAll('[data-babalu-gallery-video]').forEach(init);
})();
